import {
  TBody,
  THead,
  Table,
  TableWrapper,
  Td,
  Th,
  Tr,
} from "Components/Common/Table/TableT1";
import { TypographyT40 } from "Components/Common/Typography/index";
import React, { Fragment } from "react";
import moment from "moment";
const RoutesDetailsTable = (props) => {
  const { selectItemForMoreInformationPopup } = props;
  return (
    <Fragment>
      <TableWrapper>
        <Table>
          <THead>
            <Tr>
              <Th>Location</Th>
              <Th>Arrival Date</Th>
              {/* <Th>Revised Actual Time of Arr.</Th> */}
              <Th>Status</Th>
            </Tr>
          </THead>
          <TBody>
            {(selectItemForMoreInformationPopup.events || []).map(
              (ele, index) => {
                const numberOflist = (
                  selectItemForMoreInformationPopup.events || []
                ).filter((list) => list.location === ele.location);
                const findIndex = (
                  selectItemForMoreInformationPopup.events || []
                ).findIndex((list) => list.location === ele.location);
                return (
                  <Fragment key={index}>
                    <Tr>
                      {findIndex === index && (
                        <Td rowSpan={numberOflist.length}>
                          <TypographyT40>{ele.name}</TypographyT40>
                        </Td>
                      )}
                      <Td>
                        <TypographyT40>
                          {ele.date &&
                            moment(ele.date).format("DD/MM/YYYY,HH:mm:SS")}
                        </TypographyT40>
                      </Td>
                      {/* <Td>
                        <TypographyT40>
                          {ele.date &&
                            moment(ele.date).format("DD/MM/YYYY,HH:mm:SS")}
                            -
                        </TypographyT40>
                      </Td> */}
                      <Td>
                        <TypographyT40>{ele.description}</TypographyT40>
                      </Td>
                    </Tr>
                  </Fragment>
                );
              }
            )}
          </TBody>
        </Table>
      </TableWrapper>
    </Fragment>
  );
};

export default RoutesDetailsTable;
